/**
 * [未使用] このファイルは現在使用されていません。
 * FE-REQ-001対応により、カレンダーから日付クリック時はトップ画面(/top/${date})に遷移するようになりました。
 * 睡眠時間の編集はトップ画面で直接行う仕様に変更されています。
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { MyAnalytics, PageTopButton } from '../atoms';
import HeaderTitle from "../atoms/HeaderTitle";
import LoginFilter from "../atoms/LoginFilter";
import { getSleepRecord, saveSleepRecord } from "../store/actions";

const SleepInput = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { date } = useParams();

  const [bedtime, setBedtime] = useState('');
  const [wakeupTime, setWakeupTime] = useState('');
  const [defaultBedtime, setDefaultBedtime] = useState('22:00');
  const [defaultWakeupTime, setDefaultWakeupTime] = useState('06:00');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadRecord();
  }, [date]);

  const loadRecord = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getSleepRecord(date));
      if (response) {
        setBedtime(response.bedtime || '');
        setWakeupTime(response.wakeup_time || '');
        setDefaultBedtime(response.default_bedtime || '22:00');
        setDefaultWakeupTime(response.default_wakeup_time || '06:00');
      }
    } catch (err) {
      console.error('Failed to load sleep record:', err);
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      await dispatch(saveSleepRecord({
        record_date: date,
        bedtime: bedtime || null,
        wakeup_time: wakeupTime || null,
      }));
      setMessage('保存しました');
      setTimeout(() => {
        navigate('/sleep');
      }, 1000);
    } catch (err) {
      console.error('Failed to save sleep record:', err);
      setMessage('保存に失敗しました');
    }
    setSaving(false);
  };

  const useDefaultBedtime = () => {
    setBedtime(defaultBedtime);
  };

  const useDefaultWakeupTime = () => {
    setWakeupTime(defaultWakeupTime);
  };

  // 日付をフォーマット
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    return `${parts[0]}年${parseInt(parts[1])}月${parseInt(parts[2])}日`;
  };

  return (
    <div className="l-wrap">
      <LoginFilter />
      <HeaderTitle />
      <MyAnalytics />

      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        padding: '60px 0 30px',
        backgroundColor: '#eff9ff',
        minHeight: '100vh'
      }}>
        <div style={{ padding: '20px 15px' }}>
          <h2 style={{
            textAlign: 'center',
            fontSize: '18px',
            marginBottom: '20px',
            color: '#333'
          }}>
            {formatDate(date)}
          </h2>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>読み込み中...</div>
          ) : (
            <>
              {/* 起床時刻 */}
              <div style={{
                marginBottom: '25px',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px'
              }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#666'
                }}>
                  起床時刻
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    type="time"
                    value={wakeupTime}
                    onChange={(e) => setWakeupTime(e.target.value)}
                    style={{
                      flex: 1,
                      padding: '12px',
                      fontSize: '18px',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                  />
                  <button
                    onClick={useDefaultWakeupTime}
                    style={{
                      padding: '10px 15px',
                      backgroundColor: '#e0e0e0',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    初期値
                  </button>
                </div>
                <small style={{ color: '#999', fontSize: '12px' }}>
                  デフォルト: {defaultWakeupTime}
                </small>
              </div>

              {/* 就寝時刻 */}
              <div style={{
                marginBottom: '25px',
                padding: '15px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px'
              }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#666'
                }}>
                  就寝時刻
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    type="time"
                    value={bedtime}
                    onChange={(e) => setBedtime(e.target.value)}
                    style={{
                      flex: 1,
                      padding: '12px',
                      fontSize: '18px',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                  />
                  <button
                    onClick={useDefaultBedtime}
                    style={{
                      padding: '10px 15px',
                      backgroundColor: '#e0e0e0',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    初期値
                  </button>
                </div>
                <small style={{ color: '#999', fontSize: '12px' }}>
                  デフォルト: {defaultBedtime}
                </small>
              </div>

              {message && (
                <div style={{
                  textAlign: 'center',
                  padding: '10px',
                  marginBottom: '15px',
                  backgroundColor: message.includes('失敗') ? '#ffebee' : '#e8f5e9',
                  color: message.includes('失敗') ? '#c62828' : '#2e7d32',
                  borderRadius: '4px'
                }}>
                  {message}
                </div>
              )}

              {/* ボタンエリア - 時刻入力欄の30px下に配置 */}
              <div style={{
                marginTop: '30px',
                display: 'flex',
                gap: '10px',
                justifyContent: 'center'
              }}>
                <button
                  className="c-btn c-btn-line c-btn-xl"
                  onClick={() => navigate("/sleep")}
                  style={{ flex: 1 }}
                >
                  戻る
                </button>
                <button
                  className="c-btn c-btn-solid c-btn-xl"
                  onClick={handleSave}
                  disabled={saving || loading}
                  style={{ flex: 1 }}
                >
                  {saving ? '保存中...' : '保存'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      <PageTopButton />
    </div>
  );
};

export default SleepInput;
